import React, { useMemo, useState, useEffect } from 'react'
import { FaBook, FaThumbsUp, FaThumbsDown, FaRegIdCard, FaBuilding, FaAddressCard } from 'react-icons/fa'
import { Wrapper, BarStrip, ProgressBar, TextFieldIcon, SelectFieldIcon } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { Formik } from 'formik'
import { Bar } from 'react-chartjs-2';
import { values } from 'lodash'

const steps = [
  "Pending", "Actioned"
]

const ActionField = ( record ) => {
    return (

        <div onClick={async () => {
            try {
                const email = btoa(localStorage.getItem( "email" )); // Base64 encode
                const url = process.env.REACT_APP_API_URL+`/api/auth/get_file_details/${record.value}/${email}`
                const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                if (newWindow) newWindow.opener = null
            } catch (error) {}
        } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
            {`View`}
        </div>
    )
}

export default function ApprovedList( ) {

    const columns = useMemo( () => [
        {
        Header: "#",
        accessor: "recordId"
        },
        {
        Header: "Email",
        accessor: "email_address"
        },
        {
        Header: "Applicant",
        accessor: "applicant"
        },
        {
        Header: "Annual Income",
        accessor: "annual_income"
        },
        {
        Header: "ISIC Codes",
        accessor: "isic_codes"
        },
        {
        Header: "Date Signed",
        accessor: "date"
        },
        {
        Header: "Action",
        accessor: "id",
        Cell: ActionField
        }
    ])
    
    const [ auditReportRecords, setAuditReportRecords ] = useState( [] )
    const [ records, setRecords ] = useState( [] )
    const [ loading, setLoading ] = useState( true )

    React.useEffect( () => {
        if( loading ) {
            fetchApplications()
        }
    },[ loading ])

    const fetchApplications = async () => {
        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` )  

            if( response.data ) {
                let results = []

                if ( localStorage.getItem("link") === "approved_list") {

                    results = response.data.map( ( result, index ) => {
                        return {
                          recordId: `${index+1}`,
                          annual_income: result.annual_turnover,
                          stage: result.stage,
                          isic_codes: result.service_name,
                          applicant: result.trading_name,
                          email_address: result.created_by, 
                          status: result.status, 
                          date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                          id: result.id
                        }
                    }).filter( record => record?.stage === "9")
                } else if( localStorage.getItem("link") === "pending_list"){

                    results = response.data.map( ( result, index ) => {
                        return {
                          recordId: `${index+1}`,
                          annual_income: result.annual_turnover,
                          stage: result.stage,
                          isic_codes: result.service_name,
                          applicant: result.trading_name,
                          email_address: result.created_by, 
                          status: result.status, 
                          date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                          id: result.id
                        }
                    }).filter( record => record?.stage === "8" )
                }

                console.log(response.data)

                //update the state
                setRecords( results )
                setLoading( false )
            }
        } catch (error) {
            console.log(error)
            alert( "Server error occurred." )
            setLoading( false )
        }
    }

    const handleReportsSearch = async (values) => {

        try {
            // const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/getApprovedList`, {
            //     from_date: values.from_date,
            //     to_date: values.to_date,
            // })
            
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` )

            console.log("application id ==> "+values.application_id)
    
            if( response.data.success === true ) {
                const results = response.data.records.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        email_address: result.created_by,
                        date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } )
                console.log(response.data)
                console.log("search is done")

                //update the state
                setRecords( results )
                setLoading( false )
            }
        } catch (error) {}
    }


    return (
        <Wrapper>
            <div className="flex flex-col h-full">
                <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                    <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                    {( localStorage.getItem("link") === "approved_list") && `Approved Applications List`}
                    {( localStorage.getItem("link") === "pending_list") && `Pending Applications List`}
                    </div>

                    <div className="flex flex-col justify-center w-full bg-white">
                        <Formik initialValues={{
                            from_date: values.from_date,
                            to_date: values.to_date,

                            }} onSubmit={handleReportsSearch}>
                            { ( { handleSubmit, handleBlur, handleChange, values } ) => {
                                    return (
                                        <form className="my-2 bg-white" onSubmit={handleSubmit}>
                                            <div className="flex row px-5">
                                                <div className="basis-1/4">
                                                    <TextFieldIcon 
                                                        type="date"
                                                        name="from_date"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.from_date}
                                                        iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                        label="From"
                                                        required={true}
                                                        disabled={false}
                                                        question="From" 
                                                    />
                                                </div>

                                                <div className="basis-1/4">
                                                    <TextFieldIcon 
                                                        type="date"
                                                        name="to_date"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.to_date}
                                                        iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                        label="To"
                                                        required={true}
                                                        disabled={false}
                                                        question="To" 
                                                    />
                                                </div>

                                                <div className="basis-1/4 pt-2">
                                                    <div className="w-full pt-6 grid grid-cols-1">
                                                        <button className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="submit" name="submit">Submit</button>
                                                    </div>
                                                    {/* <SelectFieldIcon 
                                                        name="application_id"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.application_id}
                                                        iconComponent={<FaBuilding color={`#AFC836`} />} 
                                                        label="Search Application"
                                                        required={false}
                                                        disabled={false}
                                                        options={applicationsDropdown.map( ( { id, label, value } ) => {
                                                            return { id, label, value }
                                                        } )}
                                                        question="Search Application" 
                                                    /> */}
                                                </div>

                                                <div className="basis-1/4">
                                                    
                                                </div>                                                    
                                            </div>
                                        </form>
                                    )
                                }  }
                        </Formik>
                    
                        <Table 
                        rightButton={false}
                        rightBtnCallback={ () => {}}
                        rightButtonLabel={null}
                        label="My Reports"
                        columns={columns}
                        data={records}
                        hidePagination={false}
                        exportToExcel={() => {}}
                        exportToCSV={() => {}}
                        />
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}